import { JSEncrypt } from 'jsencrypt'
import { RES_PUBLIC_KEY } from '@/utils/config'
import moment from 'moment'
import BigNumber from 'bignumber.js'
import Decimal from 'decimal.js'
import dayjs from 'dayjs'

const encrypt = new JSEncrypt()
encrypt.setPublicKey(RES_PUBLIC_KEY)
const MAX_ENCRYPT_SIZE = 117
const ProductLang = {
  zh: '中文',
  // hk: '繁体',
  en: '英文',
  // ko: '韩文',
  // jp: '日文',
  // ru: '俄文',
  // tr: '土耳其文',
  vi: '越南文',
  // th: '泰文',
}
export const numMul = (num1, num2) =>
  new Decimal(num1).mul(new Decimal(num2)).toString()

export const numAdd = (num1, num2) =>
  new Decimal(num1).add(new Decimal(num2)).toString()

export const numSub = (num1, num2) =>
  new Decimal(num1).sub(new Decimal(num2)).toString()

export const numDiv = (num1, num2) =>
  new Decimal(num1).div(new Decimal(num2)).toString()

export const thousandSeparator = (value, digit) => {
  const temp = new BigNumber(value)

  return temp.toFormat(digit)
}
export const dateFormat = (value) => {
  if (!value) {
    return '-'
  }
  return moment(value).format('YYYY-MM-DD HH:mm:ss')
}
export const getLanguages = () => {
  const result = []
  for (const key in ProductLang) {
    result.push({ lang: key, label: ProductLang[key], value: '' })
  }
  return result
}
export const dateShortcuts = () => {
  return [
    {
      text: '昨日',
      value: (() => {
        const start = new Date()
        start.setDate(start.getDate() - 1)
        return [start, start]
      })(),
    },
    {
      text: '近一周',
      value: (() => {
        const end = new Date()
        const start = new Date()
        start.setDate(start.getDate() - 7)
        return [start, end]
      })(),
    },
    {
      text: '本月',
      value: (() => {
        const end = new Date()
        const start = new Date()
        start.setDate(1)
        return [start, end]
      })(),
    },
  ]
}

export const getTimeWithStartEnd = (date, type) => {
  const time = type === 'end' ? '23:59:59' : '00:00:00'
  const str = `${date.getFullYear()}-${
    date.getMonth() + 1
  }-${date.getDate()} ${time}`
  return dayjs(str).toDate()
}
// RSA 加密
const encryptFn = (val, withTimeStamp) => {
  let jsonStringify = val
  if (typeof val !== 'string') {
    jsonStringify = JSON.stringify(val)
  }
  if (withTimeStamp) {
    // 在数据的尾部带上毫秒级别时间戳
    jsonStringify += `#${new Date().getTime()}`
  }
  const stringSplit = stringSplitFunc(jsonStringify)
  const a = stringArrayEncryptFunc(stringSplit).join(',')
  return a
}

function stringSplitFunc(str) {
  if (str.length < MAX_ENCRYPT_SIZE) return [str]
  const strArr = []
  let len = 0
  // eslint-disable-next-line
  while (true) {
    const endSize = MAX_ENCRYPT_SIZE + len
    const s = str.substring(len, endSize)
    if (s.length === 0) break
    strArr.push(s)
    len = endSize
  }
  return strArr
}

function stringArrayEncryptFunc(strArr) {
  return strArr.map((item) => encrypt.encrypt(item))
}

export default encryptFn
